import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { SetupAutoResponseComponent } from '@app/two-way/setup/components/setup-auto-response/setup-auto-response.component';

/* 
  Guard to prevent navigation away from the SetupAutoResponseComponent
  if there are unsaved changes.
*/
@Injectable({ providedIn: 'root' })
export class UnsavedAutoResponseGuard implements CanDeactivate<SetupAutoResponseComponent> {
    canDeactivate(
        component: SetupAutoResponseComponent,
        _currentRoute: ActivatedRouteSnapshot,
        _currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot,
    ) {
        return component.canDeactivate();
    }
}
